import { Pipe, PipeTransform } from '@angular/core';

import { User } from '@app/core/models/user.models';
import { userToFullName } from '@app/core/utilities/user.utilities';

@Pipe({ name: 'userName' })
export class UserNamePipe implements PipeTransform {
  transform(user: User): string {
    return userToFullName(user);
  }
}
